var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{staticClass:"header_container"}),_c('main',{ref:"mainRef",staticClass:"main_container main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }